import { CheckOutlined, LoadingOutlined } from "@ant-design/icons";
import { Button, Checkbox, Col, Form, Input, Modal, Row, Spin } from "antd";
import React, { useEffect, useState } from "react";
import { GetActiveAttributesApi } from "../../../api/attributes/GetActiveAttributesApi";
import CreatePlanTemplateApi from "../../../api/plan-templates/CreatePlanTemplateApi";
import {
  openNotificationError,
  openNotificationSuccess,
} from "../../../helpers/NotificationHelpers";
import Theme from "../../../theme/Theme";
import ColorPicker from "../../sub/ColorPicker";

function AddPlanTemplateModal(props) {
  const [submit, setSubmit] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const [color, setColor] = useState("#03a9f4");

  function handleCancel() {
    setColor("#03a9f4");
    setSubmit(false);
    props.handleCancel();
  }

  useEffect(() => {
    if (props.visible) {
      getAttributes();
    }
  }, [props.visible]);

  async function getAttributes() {
    const apiResponse = await GetActiveAttributesApi();
    if (apiResponse.success) {
      setAttributes(apiResponse.data);
    }
  }

  async function onFinish(value) {
    setSubmit(true);

    const apiResponse = await CreatePlanTemplateApi(
      value.name,
      value.planLevelName,
      color,
      value.fixedAttributes?.includes("description"),
      value.fixedAttributes?.includes("tasks"),
      value.fixedAttributes?.includes("kpi"),
      true,
      value.fixedAttributes?.includes("targetDate"),
      value.customAttributes
    );

    if (apiResponse.error) {
      openNotificationError("bottomRight", apiResponse.message);
    } else if (apiResponse.success) {
      openNotificationSuccess("bottomRight", "Template added successfully");
      props.handleOk();
    } else {
      openNotificationError(
        "bottomRight",
        "Couldn't add template. Try again later."
      );
    }
    handleCancel();
  }

  function renderAttributes() {
    let output = [];
    attributes?.forEach((attribute) => {
      output.push(
        <Col span={8}>
          <Checkbox value={attribute.id}>{attribute.name}</Checkbox>
        </Col>
      );
    });
    return output;
  }

  return (
    <Modal
      title="Add new template"
      visible={props.visible}
      onCancel={() => handleCancel()}
      footer={null}
      destroyOnClose={true}
    >
      <Form
        name="addPlanTemplate"
        onFinish={onFinish}
        layout="vertical"
        requiredMark={false}
        autoComplete="off"
        initialValues={{
          color: color || "#03a9f4",
        }}
      >
        <Form.Item
          label="Template name*"
          name="name"
          rules={[
            {
              required: true,
              message: "Please enter template name!",
            },
          ]}
        >
          <Input placeholder="Template name" />
        </Form.Item>

        <Form.Item
          label="Top level name*"
          extra="Give name in singular form"
          name="planLevelName"
          rules={[
            {
              required: true,
              message: "Please enter level name!",
            },
          ]}
        >
          <Input placeholder="Level name" />
        </Form.Item>

        <Form.Item label="Top level color*" name="color">
          <div className="w-20 h-8">
            <ColorPicker color={color} onChange={(value) => setColor(value)} />
          </div>
        </Form.Item>

        <Form.Item label="Fixed attributes" name="fixedAttributes">
          <Checkbox.Group style={{ width: "100%" }}>
            <Row>
              <Col span={8}>
                <div className="flex items-center">
                  <div
                    className="mr-2 w-4 h-4 rounded flex justify-center items-center"
                    style={{
                      backgroundColor: Theme().primary,
                    }}
                  >
                    <CheckOutlined
                      style={{ fontSize: "10px", color: "#fff" }}
                    />
                  </div>
                  Target
                </div>
              </Col>
              <Col span={8}>
                <Checkbox value={"targetDate"}>Target date</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value={"description"}>Description</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value={"kpi"}>KPI</Checkbox>
              </Col>
              <Col span={8}>
                <Checkbox value={"tasks"}>Tasks</Checkbox>
              </Col>
            </Row>
          </Checkbox.Group>
        </Form.Item>

        <Form.Item name="customAttributes">
          <Checkbox.Group style={{ width: "100%" }}>
            <Row>{renderAttributes()}</Row>
          </Checkbox.Group>
        </Form.Item>

        <Form.Item style={{ marginBottom: 0 }}>
          <div className=" flex justify-end">
            <Button className="mr-3 w-28" onClick={() => handleCancel()}>
              Cancel
            </Button>
            <Button
              className="btn w-32"
              type="primary"
              htmlType={submit && "submit"}
              disabled={submit}
            >
              {submit ? (
                <Spin
                  size="small"
                  indicator={<LoadingOutlined style={{ color: "#fff" }} spin />}
                />
              ) : (
                "Add"
              )}
            </Button>
          </div>
        </Form.Item>
      </Form>
    </Modal>
  );
}

export default AddPlanTemplateModal;
